module.exports = __webpack_public_path__ + "static/img/information_bg.dacde446.png";